var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"btn",attrs:{"type":"button"}},_vm.$listeners),[(_vm.active)?_c('IconChevronUp',{staticClass:"chevron"}):_c('IconChevronDown',{staticClass:"chevron"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }